<template>
  <div class="journal">
    <!-- 操作日志 -->

    <div class="top">
      <Date-picker
        v-model="datemodel"
        @on-change="changeDate"
        class="data-pick"
        type="daterange"
        :options="options2"
        placement="bottom-end"
        placeholder="选择日期"
        style="width: 250px"
      ></Date-picker>
      <Input
        placeholder="搜索"
        class="journal-input"
        @on-enter="getlogList()"
        v-model.trim="noteItem"
        clearable
        @on-clear="getlogList"
      >
        <Icon type="ios-search" slot="prefix" @click="getlogList" />
      </Input>
      <Button
        class="title-btn fourSize"
        type="success"
        ghost
        @click="goExportLogList"
        >导出</Button
      >
    </div>
    <div class="journal-tablie">
      <Table
        @on-sort-change="changesort"
        stripe
        @on-selection-change="changeSelect"
        :columns="columns"
        :data="data"
      ></Table>
    </div>
    <div class="page-div">
      <div class="page-div-left">
        已选 <span>{{ selectNum }}</span> 条
      </div>
      <Page
        @on-page-size-change="changepage"
        :total="tableObj.total"
        show-elevator
        show-total
        @on-change="changecurrent"
        :current="pageNum"
        :page-size="pagesize"
        show-sizer
        class="page-div-page"
      />
    </div>
    <Alert class="alertTitle" v-show="alertTitleIshow" show-icon type="success"
      >操作成功</Alert
    >
    <Alert
      class="alertTitle"
      v-show="alertTitleIshow2"
      type="error"
      show-icon
      >{{ alertTitle }}</Alert
    >
    <!-- <Spin fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin> -->
  </div>
</template>
<script>
    import {
        logList
    } from "../servers/api";
    export default {
        name: "Journal",
        data() {
            return {
                alertTitle: "",
                alertTitleIshow2: false,
                alertTitleIshow: false,
                isiconfontshow: false,
                options2: {
                    shortcuts: [{
                        text: "最近一周",
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            return [start, end];
                        }
                    }, {
                        text: "最近一个月",
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            return [start, end];
                        }
                    }, {
                        text: "最近三个月",
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            return [start, end];
                        }
                    }]
                },
                columns: [{
                    type: "selection",
                    width: 70,
                    align: "center"
                }, {
                    title: "操作时间",
                    align: "center",
                    width: 200,
                    ellipsis: true,
                    sortable: true,
                    key: "createTime"
                }, {
                    title: "账号名称",
                    align: "center",
                    width: 250,
                    ellipsis: true,
                    sortable: true,
                    key: "loginName"
                }, {
                    title: "操作内容",
                    align: "center",
                    ellipsis: true,
                    sortable: true,
                    key: "note",
                    render: (h, params) => {
                        return h("div", [
                            h(
                                "span", {
                                    style: {
                                        display: "inline-block",
                                        width: "100%",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap"
                                    },
                                    domProps: {
                                        title: params.row.note
                                    }
                                },
                                params.row.note
                            )
                        ]);
                    }
                }],
                data: [],
                // current:1, //当前页
                tableObj: {}, //存储日志
                pageNum: 1,
                selectNum: 0,
                datemodel: [],
                noteItem: "",
                selectionList: [], //存储选中的列表
                isAsc: "",
                orderField: "",
                pagesize: 20
            };
        },
        created() {
            this.datazuijin();
        },
        methods: {
            datazuijin() {
                var nowdate = new Date();

                var a = nowdate.getFullYear();
                var b = nowdate.getMonth() + 1;
                var c = nowdate.getDate();
                var start = a + "-" + b + "-" + c;
                nowdate.setMonth(nowdate.getMonth() - 1);
                var d = nowdate.getFullYear();
                var e = nowdate.getMonth() + 1;
                var f = nowdate.getDate();
                var end = d + "-" + e + "-" + f;
                this.datemodel = [end, start];
                this.getlogList();
            },
            changepage(num) {
                //liaobiao切换请求条数
                this.pagesize = num;
                this.pageNum = 1;

                this.getlogList();
            },
            goExportLogList() {
                //导出
                let baseUrl = sessionStorage.getItem("baseUrl");
                let list = [];
                let token = JSON.parse(sessionStorage.getItem("login")).token || "";
                if (this.selectionList.length > 0) {
                    for (let i = 0; i < this.selectionList.length; i++) {
                        list.push(this.selectionList[i].id);
                    }
                }
                // window.location.href = baseUrl+'/wts/admin/log/exportLogList?idList='+list.join(',')+"&token="+token;
            },
            changeDate(data) {
                //获取日期
                this.datemodel = data;
                this.getlogList();
            },
            changecurrent(num) {
                //分页
                this.pageNum = num;
                this.selectionList = [];
                this.selectNum = this.selectionList.length;
                this.getlogList();
            },
            getlogList() {
                //获取日志接口
                this.selectionList = [];
                this.selectNum = this.selectionList.length;
                this.isiconfontshow = true;
                if (typeof this.datemodel[0] == "object") {
                    var d = new Date(this.datemodel[0]);
                    this.datemodel[0] =
                        d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
                }
                if (typeof this.datemodel[1] == "object") {
                    var d = new Date(this.datemodel[1]);
                    this.datemodel[1] =
                        d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
                }
                let params = {
                    pageNum: this.pageNum,
                    pageSize: this.pagesize,
                    note: encodeURIComponent(this.noteItem, "utf-8"),
                    startDate: this.datemodel[0] || "",
                    endDate: this.datemodel[1] || "",
                    orderField: this.orderField,
                    isAsc: this.isAsc
                };
                logList(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.data = res.data.data.list || [];
                        this.tableObj = res.data.data;
                        if (this.tableObj.pageNum == 0) {
                            this.pageNum = 1;
                        }
                    } else {
                        this.isiconfontshow = false;
                        this.alertTitle = res.data.msg;
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                    }
                });
            },
            changeSelect(selection) {
                //选中的select
                this.selectionList = selection;
                this.selectNum = selection.length;
            },
            changesort(item) {
                //排序
                this.isAsc = item.order;
                this.orderField = item.key;
                if (item.order == "normal") {
                    this.isAsc = "";
                    this.orderField = "";
                }
                this.selectionList = [];
                this.selectNum = this.selectionList.length;
                this.getlogList();
            }
        }
    };
</script>
<style lang="scss" scoped="" type="text/css">
    @import "../css/conmmon.scss";
    @import "../font/iconfont.css";
    .data-pick {
        // float: right;
        margin-right: 15px;
    }
    
    .top {
        width: calc(100% - 250px);
        height: 60px;
        line-height: 35px;
        position: fixed;
        top: 111px;
        z-index: 99;
        background: #fff;
        padding-top: 17px;
        left: 220px;
        padding-left: 15px;
        padding-bottom: 15px;
    }
    
    .ivu-table-wrapper /deep/ {
        font-size: 13px;
    }
    
    .page-div-page /deep/,
    .ivu-page /deep/ {
        font-size: 13px;
    }
    
    .journal {
        font-family: SimHei;
        width: 100%;
        height: 100%;
        overflow: hidden;
        overflow-y: visible;
        padding: 15px;
        padding-bottom: 30px;
        font-size: 13px;
        .journal-input {
            width: 250px;
        }
        .title-btn {
            float: right;
            width: 70px;
            margin-top: 3px;
        }
        .journal-tablie {
            padding-top: 15px;
            margin: 40px 0 60px;
        }
        .page-div {
            width: 100%;
            margin-top: 15px;
            position: fixed;
            background: #fff;
            width: calc(100% - 270px);
            height: 60px;
            z-index: 99;
            bottom: 0;
            padding-top: 15px;
            .page-div-left {
                float: left;
            }
            .page-div-page {
                float: right;
                margin-right: 15px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/shezhi/Journal.vue